import styled from 'styled-components';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import Button from '@insurancemenu/imenu-components-lib/dist/components/Button';
import { colors, StapleTableCell, StapleTableHeading, typography } from '@insurancemenu/imenu-components-lib';
import { InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';

export const ActionModalStyled = styled(ActionModal)`
  max-width: 85rem;
  width: 80%;
`;

export const ModalContentStyled = styled.div`
  margin: 5rem 0;
`;

export const ButtonStyled = styled(Button)`
  margin-left: auto;
  font-weight: 700;
  min-width: 15rem;
`;

export const HintStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  gap: 0.5rem;
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
  background-color: ${colors.red[100]};
  padding: 1.5rem;
  border-radius: 6px;
  text-align: left;
`;

export const StapleTableCellStyled = styled(StapleTableCell)`
  padding: 1.5rem;
`;

export const StapleTableHeadingStyled = styled(StapleTableHeading)`
  padding: 1.5rem;
`;

export const InfoButtonFilledStyled = styled(InfoButtonFilled)`
  flex-shrink: 0;
`;

export const AddedProductLineNameStyled = styled.span`
  color: ${colors.green[600]};
  font-weight: 700;
`;

export const RequiredProductLineNameStyled = styled.span`
  color: ${colors.red[600]};
  font-weight: 700;
`;
